import { defineStore } from 'pinia';

export const useDashboardStore = defineStore('dashboard', {
  state: () => ({
    totalDetections: 0,
    compliancePercentage: 0,
    totalViolations: 0,
    attendanceLogs: [],
    employeeIdMap: {},     // Maps names to custom IDs
    lastGeneratedId: 1000  // Starts from 1001
  }),

  actions: {
    setDashboardData(newData) {
      // Update metrics
      this.compliancePercentage = newData.compliancePercentage ?? this.compliancePercentage;
      this.totalViolations = newData.unauthorizedAccess ?? this.totalViolations;

      if (newData.logs && Array.isArray(newData.logs)) {
        // Filter out duplicate entries by employee name
        const existingNames = new Set(this.attendanceLogs.map(log => log.employee));
        const uniqueNewLogs = newData.logs.filter(log => !existingNames.has(log.employee));

        const mappedNewLogs = uniqueNewLogs.map(log => {
          const lastLog = this.attendanceLogs[this.attendanceLogs.length - 1];

          // 🧠 If last entry was "Unknown" and now same person is detected, remove "Unknown"
          if (
            lastLog &&
            lastLog.employee === 'Unknown' &&
            log.employee !== 'Unknown'
          ) {
            const lastTime = new Date(lastLog.datetime);
            const newTime = new Date(log.datetime);
            const timeDiffSeconds = Math.abs((newTime - lastTime) / 1000);
            if (timeDiffSeconds < 3) {
              this.attendanceLogs.pop();
            }
          }

          // Generate a custom ID if not already assigned
          if (!this.employeeIdMap[log.employee]) {
            this.lastGeneratedId += 1;
            this.employeeIdMap[log.employee] = this.lastGeneratedId;
          }

          const customId = this.employeeIdMap[log.employee];

          return {
            ...log,
            id: customId // Keep status, datetime as received
          };
        });

        // Add new logs to existing logs
        this.attendanceLogs = [...this.attendanceLogs, ...mappedNewLogs];
        this.totalDetections += mappedNewLogs.length;
      }
    }
  }
});
